import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputModule } from '@sla-ng/ui-material';
import { ReferenceSizeDialogComponent } from './reference-size-dialog.component';

export * from './reference-size-dialog.component';
@NgModule({
    declarations: [ ReferenceSizeDialogComponent ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        TranslateModule,
        GenericInputModule,
    ],
})
export class ReferenceSizeDialogModule {
}
